<template>
  <a slot="activator" @click="$emit('excluir')" class="icone" title="Remover">
    <v-icon>delete</v-icon>
  </a>
</template>

<script>
export default {
  name: 'BotaoExcluir',
  props: ['id']
}
</script>

<style scoped lang="stylus">
@media (max-width 720px)
  .icone i
    font-size 18px
</style>